import { render, staticRenderFns } from "./cash-collection.vue?vue&type=template&id=00249326&"
import script from "./cash-collection.vue?vue&type=script&lang=js&"
export * from "./cash-collection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports